export const isAccredited = (annualIncome, totalNetWorth, callback) => {
  const accredited = annualIncome > 4 || totalNetWorth > 5;
  callback(accredited);
};

export default {
  isAccredited,
};



// WEBPACK FOOTER //
// ./src/helpers/index.js